import { combineReducers } from '@reduxjs/toolkit'
import topBarOpen from './topBarOpen'
import savedModalOpen from './savedModalOpen'
import selected from './selected'
import applied from './applied'
import saved from './saved'
import values from './values'
import disabled from './disabled'
import firstApply from './firstApply'
import lostShoppers from './lostShoppers'
import reviewFilterValues from './reviewFilterValues'
import timeFrameTab from './timeFrameTab'
import defaultFilters from './defaultFilters'
import filterValues from './filterValues'

const filters = combineReducers({
  topBarOpen,
  timeFrameTab,
  savedModalOpen,
  selected,
  applied,
  saved,
  values,
  disabled,
  firstApply,
  lostShoppers,
  reviewFilterValues,
  defaultFilters,
  filterValues,
})

export type FilterState = ReturnType<typeof filters>

export default filters
